var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"neo-title",class:_vm.className,style:(_vm.styles)},[_c('span',{staticClass:"line"}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }